import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Screw web performance, just wait a little 😈",
  "description": "",
  "published": "2020-05-22T00:00:00.000Z",
  "redirect_from": ["/blog/screw-web-performance-just-wait-a-little/swizec/9422"],
  "categories": "Front End, Technical",
  "hero": "./img/techletter.app-screenshot-1590163368621.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Back in 2016 React performance was top of mind. Sure React makes life easy, `}<em parentName="p">{`but is it worth it?!?`}</em></p>
    <p>{`You have the DOM abstraction, the synthetic event system, the weird reconciliation, the batching of DOM updates, the ... there's a lot going on. Can it really be `}<em parentName="p">{`faster`}</em>{` than vanilla? `}{`[`}{`^1]`}</p>
    <p>{`I devised a devilish plan. An example to end all examples.`}</p>
    <p><a parentName="p" {...{
        "href": "https://swizec.com/blog/fractals-react/swizec/7233"
      }}><img parentName="a" {...{
          "src": "/0d9aee144ba12aae82007c2d18e299ea/Fractals1431ad.gif",
          "alt": "Fractals"
        }}></img></a></p>
    <p><a parentName="p" {...{
        "href": "https://swizec.com/blog/fractals-react/swizec/7233"
      }}>{`React Fractals!`}</a></p>
    <p>{`Folks from the community ❤️ helped me fix some trigonometry and the React Fractals demo became interactive:`}</p>
    <p><a parentName="p" {...{
        "href": "https://swizec.com/blog/dancing-tree-fractal-react/swizec/7288"
      }}><img parentName="a" {...{
          "src": "/b8469a16da7aa13214f4fec30edaa3bc/gifx24020d37e73.gif",
          "alt": null
        }}></img></a></p>
    <p><em parentName="p">{`Feel`}</em>{` the computer struggle to keep up. Feel it! 😈`}</p>
    <p>{`Here's the exact same code 4 years later. No changes, no library updates, nothing.`}</p>
    <p><a parentName="p" {...{
        "href": ""
      }}><img parentName="a" {...{
          "src": "/16d213456db817c6ade8a8c6d48e9bbd/wF8l8tS.gif",
          "alt": null
        }}></img></a></p>
    <p>{`🤯`}</p>
    <p>{`Try for yourself: `}<a parentName="p" {...{
        "href": "https://react-fractals.now.sh/"
      }}>{`https://react-fractals.now.sh/`}</a></p>
    <p><em parentName="p">{`PS: you can `}<a parentName="em" {...{
          "href": "https://swizec.com/blog/screw-web-performance-just-wait-a-little/swizec/9422"
        }}>{`read and share this online`}</a></em></p>
    <h2 {...{
      "id": "why-fractals-are-bad"
    }}>{`Why fractals are bad`}</h2>
    <p>{`I remember making those gifs in 2016. Had to move my mouse veeeeery carefully so they came out okay. 😅`}</p>
    <p>{`My machine was a respectable `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/MacBook_Pro#Third_generation_(Retina)"
      }}>{`first-gen MacBook Pro retina`}</a>{`. Getting up there in age but a very respectable computer with the maxed out specs. `}{`[`}{`^2]`}</p>
    <p>{`Here's the problem:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20src%2FPythagoras.js%0A%0Aconst%20Pythagoras%20%3D%20(%7B%0A%20%20%20%20w%2C%0A%20%20%20%20x%2C%0A%20%20%20%20y%2C%0A%20%20%20%20heightFactor%2C%0A%20%20%20%20lean%2C%0A%20%20%20%20left%2C%0A%20%20%20%20right%2C%0A%20%20%20%20lvl%2C%0A%20%20%20%20maxlvl%2C%0A%7D)%20%3D%3E%20%7B%0A%20%20%20%20%2F%2F%20avoid%20infinite%20recursion%0A%20%20%20%20if%20(lvl%20%3E%3D%20maxlvl%20%7C%7C%20w%20%3C%201)%20%7B%0A%20%20%20%20%20%20%20%20return%20null%3B%0A%20%20%20%20%7D%0A%0A%20%20%20%20%2F%2F%20grab%20memoized%20calculations%20for%20each%20level%0A%20%20%20%20const%20%7B%20nextRight%2C%20nextLeft%2C%20A%2C%20B%20%7D%20%3D%20memoizedCalc(%7B%0A%20%20%20%20%20%20%20%20w%3A%20w%2C%0A%20%20%20%20%20%20%20%20heightFactor%3A%20heightFactor%2C%0A%20%20%20%20%20%20%20%20lean%3A%20lean%2C%0A%20%20%20%20%7D)%3B%0A%0A%20%20%20%20let%20rotate%20%3D%20%22%22%3B%0A%0A%20%20%20%20%2F%2F%20SVG%20rotate%20transformation%2C%20not%20GPU%20accelerated%20%3A(%0A%20%20%20%20if%20(left)%20%7B%0A%20%20%20%20%20%20%20%20rotate%20%3D%20%60rotate(%24%7B-A%7D%200%20%24%7Bw%7D)%60%3B%0A%20%20%20%20%7D%20else%20if%20(right)%20%7B%0A%20%20%20%20%20%20%20%20rotate%20%3D%20%60rotate(%24%7BB%7D%20%24%7Bw%7D%20%24%7Bw%7D)%60%3B%0A%20%20%20%20%7D%0A%0A%20%20%20%20%2F%2F%20draw%0A%20%20%20%20return%20(%0A%20%20%20%20%20%20%20%20%3Cg%20transform%3D%7B%60translate(%24%7Bx%7D%20%24%7By%7D)%20%24%7Brotate%7D%60%7D%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%7B%60%2F%2F%20draw%20current%20level%60%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20width%3D%7Bw%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20height%3D%7Bw%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20x%3D%7B0%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20y%3D%7B0%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20style%3D%7B%7B%20fill%3A%20interpolateViridis(lvl%20%2F%20maxlvl)%20%7D%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%2F%3E%0A%0A%20%20%20%20%20%20%20%20%20%20%20%20%7B%60%2F%2F%20draw%20current%20level%60%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%3CPythagoras%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20w%3D%7BnextLeft%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20x%3D%7B0%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20y%3D%7B-nextLeft%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20lvl%3D%7Blvl%20%2B%201%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20maxlvl%3D%7Bmaxlvl%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20heightFactor%3D%7BheightFactor%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20lean%3D%7Blean%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20left%0A%20%20%20%20%20%20%20%20%20%20%20%20%2F%3E%0A%0A%20%20%20%20%20%20%20%20%20%20%20%20%3CPythagoras%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20w%3D%7BnextRight%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20x%3D%7Bw%20-%20nextRight%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20y%3D%7B-nextRight%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20lvl%3D%7Blvl%20%2B%201%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20maxlvl%3D%7Bmaxlvl%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20heightFactor%3D%7BheightFactor%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20lean%3D%7Blean%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20right%0A%20%20%20%20%20%20%20%20%20%20%20%20%2F%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20)%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "630px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "229.59641255605382%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'919\\'%20viewBox=\\'0%200%20400%20919\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2033c-2%203-1%20854%200%20855%202%202%20356%202%20358%200%201-1%202-852%200-855-1-3-357-3-358%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b721b601562c9d20baf34c59ec06e607/ca0a1/techletter.app-screenshot-1590163368621.webp 223w", "/static/b721b601562c9d20baf34c59ec06e607/75680/techletter.app-screenshot-1590163368621.webp 445w", "/static/b721b601562c9d20baf34c59ec06e607/8aab1/techletter.app-screenshot-1590163368621.webp 630w"],
                "sizes": "(max-width: 630px) 100vw, 630px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b721b601562c9d20baf34c59ec06e607/e92b6/techletter.app-screenshot-1590163368621.png 223w", "/static/b721b601562c9d20baf34c59ec06e607/e66bf/techletter.app-screenshot-1590163368621.png 445w", "/static/b721b601562c9d20baf34c59ec06e607/f058b/techletter.app-screenshot-1590163368621.png 630w"],
                "sizes": "(max-width: 630px) 100vw, 630px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/b721b601562c9d20baf34c59ec06e607/f058b/techletter.app-screenshot-1590163368621.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Fractals are recursive.`}</p>
    <p>{`Each `}<inlineCode parentName="p">{`<Pythagoras>`}</inlineCode>{`[`}{`^3] component renders 2 more. The angle calculations are memoized for each level to save time`}{`[`}{`^4]. Still this is a terrible case.`}</p>
    <p>{`Recursion means that every render has to re-render `}<em parentName="p">{`every element`}</em>{`. They're all dependent.`}</p>
    <p>{`At the maximum recursion level of 11 that's `}<inlineCode parentName="p">{`2^11 = 2048`}</inlineCode>{` SVG elements that React and your browser have to re-render in real time on every mouse move.`}</p>
    <p>{`Well, not `}<em parentName="p">{`every`}</em>{` mouse move – we throttle to React's pace of state updates:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20src%2FApp.js%0A%0A%2F%2F%20Throttling%20approach%20borrowed%20from%20Vue%20fork%0A%2F%2F%20https%3A%2F%2Fgithub.com%2Fyyx990803%2Fvue-fractal%2Fblob%2Fmaster%2Fsrc%2FApp.vue%0A%2F%2F%20rAF%20makes%20it%20slower%20than%20just%20throttling%20on%20React%20update%0AonMouseMove(event)%20%7B%0A%20%20%20%20if%20(this.running)%20return%3B%0A%20%20%20%20this.running%20%3D%20true%3B%0A%0A%20%20%20%20const%20%5Bx%2C%20y%5D%20%3D%20d3mouse(this.refs.svg)%2C%0A%20%20%20%20%20%20%20%20scaleFactor%20%3D%20scaleLinear()%0A%20%20%20%20%20%20%20%20%20%20%20%20.domain(%5Bthis.svg.height%2C%200%5D)%0A%20%20%20%20%20%20%20%20%20%20%20%20.range(%5B0%2C%200.8%5D)%2C%0A%20%20%20%20%20%20%20%20scaleLean%20%3D%20scaleLinear()%0A%20%20%20%20%20%20%20%20%20%20%20%20.domain(%5B0%2C%20this.svg.width%20%2F%202%2C%20this.svg.width%5D)%0A%20%20%20%20%20%20%20%20%20%20%20%20.range(%5B0.5%2C%200%2C%20-0.5%5D)%3B%0A%0A%20%20%20%20this.setState(%7B%0A%20%20%20%20%20%20%20%20heightFactor%3A%20scaleFactor(y)%2C%0A%20%20%20%20%20%20%20%20lean%3A%20scaleLean(x)%0A%20%20%20%20%7D)%3B%0A%20%20%20%20this.running%20%3D%20false%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "638px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "91.4798206278027%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'366\\'%20viewBox=\\'0%200%20400%20366\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2031l-1%20153c0%20143%200%20151%202%20152h356c2-1%202-9%202-152l-1-153c-2-2-356-2-358%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4535c594be4a6a22dac16f3d64f66cb3/ca0a1/techletter.app-screenshot-1590163368556.webp 223w", "/static/4535c594be4a6a22dac16f3d64f66cb3/75680/techletter.app-screenshot-1590163368556.webp 445w", "/static/4535c594be4a6a22dac16f3d64f66cb3/a2d8a/techletter.app-screenshot-1590163368556.webp 638w"],
                "sizes": "(max-width: 638px) 100vw, 638px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4535c594be4a6a22dac16f3d64f66cb3/e92b6/techletter.app-screenshot-1590163368556.png 223w", "/static/4535c594be4a6a22dac16f3d64f66cb3/e66bf/techletter.app-screenshot-1590163368556.png 445w", "/static/4535c594be4a6a22dac16f3d64f66cb3/41be6/techletter.app-screenshot-1590163368556.png 638w"],
                "sizes": "(max-width: 638px) 100vw, 638px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/4535c594be4a6a22dac16f3d64f66cb3/41be6/techletter.app-screenshot-1590163368556.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Mouse move events fire multiple times per frame, which means you can swamp the CPU with calculations you're not even drawing. You can use the `}<inlineCode parentName="p">{`this.running`}</inlineCode>{` trick as a lock to prevent flushing multiple `}<inlineCode parentName="p">{`setState`}</inlineCode>{` events before they finish.`}</p>
    <p>{`This worked in React 16.3.`}</p>
    <p>{`With `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/concurrent-mode-intro.html"
      }}>{`concurrent mode in the future`}</a>{` this becomes trickier.`}</p>
    <h2 {...{
      "id": "why-this-code-works-so-well-in-2020"
    }}>{`Why this code works so well in 2020`}</h2>
    <p>{`Imagine my surprise when I go to see if React's concurrent mode makes this faster and it's already smooth as butter.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1263663856779321346"
      }}><img parentName="a" {...{
          "src": "/static/media/error.4c412ab4.png",
          "alt": "Click through for source"
        }}></img></a></p>
    <p>{`A few things happened since 2016 my friend.`}</p>
    <p>{`JavaScript itself got faster. 4 years of research and development on the V8 engine, DOM manipulation, etc. Lots of very smart people working on that.`}</p>
    <p>{`Computers got faster too.`}</p>
    <p>{`We might not be getting record breaking CPU gigahertz every year, but `}<a parentName="p" {...{
        "href": "https://reactfordataviz.com/articles/moores-law/"
      }}>{`Moore's Law is far from dead`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://reactfordataviz.com/articles/moores-law/"
      }}><img parentName="a" {...{
          "src": "/b97c708c07b5ba7675c978b0a51c75ba/W3OVpFL.gif",
          "alt": null
        }}></img></a></p>
    <p>{`My current computer is a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/MacBook_Pro#Fifth_generation_(Magic_Keyboard)"
      }}>{`16" MacBook Pro`}</a>{`. Same 16GB of RAM, `}<em parentName="p">{`less`}</em>{` speed per core at 2.4GHz – but there's 8 of them instead of 4. And the RAM chips are faster and the motherboard is faster and everything around the CPU is faster.`}</p>
    <p>{`While my code stayed the same `}<em parentName="p">{`my environment`}</em>{` got faster.`}</p>
    <p>{`That's the beauty of working on the web. Your work keeps improving all on its own.`}</p>
    <h2 {...{
      "id": "why-webapps-keep-getting-slower"
    }}>{`Why webapps keep getting slower`}</h2>
    <p>{`Before you ask why the web `}<em parentName="p">{`feels`}</em>{` slower and slower despite these wonderful advances in computing and browser technology ...`}</p>
    <p>{`... because nobody's waiting. They keep adding shit.`}</p>
    <p>{`Sit back and relax my friend. You don't need the new feature. You don't need the next shiny. Chill.`}</p>
    <p>{`Let your environment make your code better.`}</p>
    <p><img parentName="p" {...{
        "src": "/204e5de4c8186ce3f67063fa7668c3c9/media-9u1J84ZtCSl9K-giphy.gif",
        "alt": "relax giphy"
      }}></img></p>
    <p>{`✌️`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>
    <p>{`[`}{`^1]: technically React `}<em parentName="p">{`can't`}</em>{` be faster than vanilla because there's a layer of overhead. Your manual solution will be faster `}<em parentName="p">{`if you're crazy careful`}</em>{`. Most likely it's going to end up slower and messier or you'll end up reinventing React.`}</p>
    <p>{`[`}{`^2]: maxed out specs for `}<a parentName="p" {...{
        "href": "https://everymac.com/systems/apple/macbook_pro/specs/macbook-pro-core-i7-2.7-15-mid-2012-retina-display-specs.html"
      }}>{`my computer in 2016`}</a>{` were a quad-core 2.7Ghz processor with 16GB of RAM. 🤘`}</p>
    <p>{`[`}{`^3]: this is a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Pythagoras_tree_(fractal)"
      }}>{`pythagorean fractal`}</a>{` at core. Also known as the Khoch Curve when it wiggles like that. Names after Pythagoras because the noncurvy (45deg) version encloses a right triangle between each 3 points.`}</p>
    <p>{`[`}{`^4]: each level of recursion renders multiple squares. Hundreds towards the end. They all have the same angles relative to the parent square so we can avoid calculating each one by `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/react-fractals/blob/master/src/Pythagoras.js#L8"
      }}>{`memoizing the function`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      